import React from "react";
import "../styles/TermsOfUse.css";

export default function TermsOfUse() {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <h1 className="terms-title">Terms of Use - MediCoin ICO</h1>
        
        <div className="terms-meta">
          <p><strong>Last Updated:</strong> November 8, 2025</p>
          <p><strong>Effective Date:</strong> November 8, 2025</p>
        </div>

        <section className="terms-section">
          <h2>1. Introduction</h2>
          <p>
            These Terms of Use ("Terms") establish the legal agreement between you (the "User") and MediCoin, which is managed and operated by MediCureOn LLC ("Company," "we," "us," "our"), governing your access to and use of our website and ICO platform (collectively, the "Services").
          </p>
          <p>
            <strong>What is MediCoin?</strong> MediCoin (MCN) is a <strong>utility token</strong> designed to be the native currency of the MediCureOn Wellness Platform. 
            Unlike speculative or meme coins with no real utility, MediCoin provides tangible value: it enables secure healthcare payments, 
            facilitates decentralized medical data sharing, powers telehealth services, rewards wellness activities, and grants access to premium 
            healthcare features within the MediCureOn ecosystem. MediCoin is directly managed and operated by MediCureOn LLC as an integral 
            component of our comprehensive healthcare and wellness platform—not as a standalone speculative cryptocurrency.
          </p>
          <p>
            By accessing, browsing, or using our Services, you acknowledge that you have read, understood, and agree to be bound by these Terms. If you do not agree, please do not use our Services.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Important Legal Disclaimers</h2>
          <div className="warning-box">
            <p className="warning-title">⚠️ CRITICAL INFORMATION:</p>
            <ul>
              <li>
                <strong>Not Securities:</strong> MediCoin (MCN) tokens are not securities. Purchases during the ICO phase are voluntary contributions to access ecosystem utility features on the MediCureOn Wellness Platform, which is owned and operated by MediCureOn LLC.
              </li>
              <li>
                <strong>Final and Non-Refundable:</strong> All purchases are final and non-refundable. Please read carefully before participating.
              </li>
              <li>
                <strong>Regulatory Risk:</strong> Cryptocurrency and token regulations are evolving. You assume all legal and financial risks associated with token purchases.
              </li>
              <li>
                <strong>No Guarantees:</strong> Past performance or roadmap plans do not guarantee future results. MediCoin development and features may change at any time.
              </li>
            </ul>
          </div>
        </section>

        <section className="terms-section">
          <h2>3. Eligibility and User Accounts</h2>
          <p><strong>3.1 Age Requirement:</strong> You must be at least 18 years old to participate in the MediCoin ICO. Users under 18 are not permitted to purchase tokens.</p>
          
          <p><strong>3.2 Account Information:</strong> You agree to provide accurate, truthful information when creating an account or wallet. You are responsible for maintaining the confidentiality of your login credentials and private keys, and are fully responsible for all activities under your account.</p>
          
          <p><strong>3.3 Account Security:</strong> You agree to use strong passwords and enable multi-factor authentication (MFA) when available. Loss of private keys or account access is your sole responsibility. We cannot recover lost wallets or funds.</p>
        </section>

        <section className="terms-section">
          <h2>4. User Responsibilities</h2>
          <p><strong>4.1 Lawful Use:</strong> You agree not to use our Services for any illegal purpose or in violation of any applicable laws or regulations in your jurisdiction.</p>
          
          <p><strong>4.2 Prohibited Activities:</strong> You agree not to:</p>
          <ul>
            <li>Engage in fraud, hacking, or unauthorized access to our systems</li>
            <li>Distribute malware, viruses, or malicious code</li>
            <li>Spam or send unsolicited messages</li>
            <li>Infringe on intellectual property rights</li>
            <li>Harass, defame, or threaten other users or the Company</li>
            <li>Reverse engineer or attempt to gain unauthorized access to our platform</li>
            <li>Use automated bots or scripts to interact with our Services</li>
          </ul>
          
          <p><strong>4.3 Compliance Responsibility:</strong> You are solely responsible for complying with all applicable laws and regulations in your country, state, and jurisdiction regarding cryptocurrency and token purchases. MediCoin does not provide legal or financial advice.</p>
        </section>

        <section className="terms-section">
          <h2>5. Intellectual Property Rights</h2>
          <p><strong>5.1 Company IP:</strong> All content, software, trademarks, logos, and designs on our platform are owned by MediCoin or licensed to us. You may not reproduce, modify, or distribute this content without explicit written permission.</p>
          
          <p><strong>5.2 Limited License:</strong> We grant you a limited, non-exclusive, non-transferable license to access and use our Services for personal participation in the ICO only.</p>
          
          <p><strong>5.3 Blockchain Transparency:</strong> All token transactions recorded on the Ethereum blockchain are publicly visible and immutable. MediCoin does not control blockchain data.</p>
        </section>

        <section className="terms-section">
          <h2>6. Limitation of Liability</h2>
          <p><strong>6.1 Disclaimer:</strong> Our Services are provided on an "as-is" basis without warranties of any kind, expressed or implied. We do not warrant that our Services will be uninterrupted, error-free, completely secure, or suitable for your purposes.</p>
          
          <p><strong>6.2 Liability Cap:</strong> In no event shall MediCoin's total liability for any claims exceed $100 USD or the amount you paid for tokens, whichever is greater.</p>
          
          <p><strong>6.3 Excluded Damages:</strong> MediCoin is not liable for any indirect, incidental, special, or consequential damages, including but not limited to loss of revenue, data, profits, or business opportunity, even if advised of the possibility of such damages.</p>
          
          <p><strong>6.4 Market Volatility:</strong> We are not responsible for price volatility, market conditions, exchange rate fluctuations, or value loss of MCN tokens after purchase.</p>
        </section>

        <section className="terms-section">
          <h2>7. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless MediCoin, its officers, directors, employees, and agents from any claims, damages, or costs (including legal fees) arising from:
          </p>
          <ul>
            <li>Your violation of these Terms</li>
            <li>Your use of our Services or ICO platform</li>
            <li>Your violation of any third-party rights</li>
            <li>Your violation of any applicable laws or regulations</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>8. Termination</h2>
          <p><strong>8.1 By You:</strong> You may stop using our Services at any time by ceasing to access the platform.</p>
          
          <p><strong>8.2 By Us:</strong> We may terminate or suspend your account if you violate these Terms, engage in illegal activity, or pose a security risk to other users or the platform.</p>
          
          <p><strong>8.3 Effect of Termination:</strong> Upon termination, your access to our Services will be immediately revoked. Blockchain transactions are permanent and cannot be reversed.</p>
        </section>

        <section className="terms-section">
          <h2>9. Data Security</h2>
          <p><strong>9.1 Encryption:</strong> All data is encrypted in transit (TLS 1.2+) and at rest (AES-256 encryption).</p>
          
          <p><strong>9.2 Access Controls:</strong> We implement multi-factor authentication (MFA) and role-based access controls for staff.</p>
          
          <p><strong>9.3 Breach Notification:</strong> In the event of a data breach affecting your information, we will notify you within 72 hours as required by applicable law.</p>
          
          <p><strong>9.4 Wallet Security:</strong> We are not responsible for loss, theft, or unauthorized access to your wallet or private keys. You are solely responsible for securing your private keys and wallet credentials.</p>
        </section>

        <section className="terms-section">
          <h2>10. Third-Party Services and Links</h2>
          <p><strong>10.1 External Links:</strong> Our Services may contain links to third-party websites (Etherscan, wallet providers, exchanges, etc.). We are not responsible for the content, accuracy, or practices of external sites.</p>
          
          <p><strong>10.2 Third-Party Wallets:</strong> Your use of MetaMask, WalletConnect, or other third-party wallets is subject to their respective terms and privacy policies. We are not liable for third-party wallet malfunctions or security breaches.</p>
          
          <p><strong>10.3 Blockchain Providers:</strong> Our Services rely on blockchain infrastructure providers (Ethereum nodes, RPC providers). We are not liable for blockchain network disruptions or transaction failures.</p>
        </section>

        <section className="terms-section">
          <h2>11. Modification of Services</h2>
          <p><strong>11.1 Right to Modify:</strong> We reserve the right to modify, suspend, or discontinue Services with 30 days' notice.</p>
          
          <p><strong>11.2 Updates to Terms:</strong> We may update these Terms periodically. Your continued use of the Services constitutes acceptance of updated Terms. Material changes will be communicated via email.</p>
        </section>

        <section className="terms-section">
          <h2>12. Governing Law and Jurisdiction</h2>
          <p><strong>12.1 Governing Law:</strong> These Terms are governed by the laws of the State of Wisconsin, USA, without regard to conflict of law principles.</p>
          
          <p><strong>12.2 Jurisdiction:</strong> You agree to submit to the exclusive jurisdiction of the state and federal courts located in Milwaukee County, Wisconsin for any disputes arising from these Terms.</p>
        </section>

        <section className="terms-section">
          <h2>13. Dispute Resolution</h2>
          <p><strong>13.1 Informal Resolution:</strong> Before pursuing formal action, parties agree to attempt resolution through good-faith negotiation.</p>
          
          <p><strong>13.2 Arbitration:</strong> Any unresolved disputes shall be subject to binding arbitration through JAMS (Judicial Arbitration and Mediation Services).</p>
          
          <p><strong>13.3 Small Claims:</strong> Either party may bring small claims in their local small claims court.</p>
        </section>

        <section className="terms-section">
          <h2>14. Compliance with Laws</h2>
          <p>You agree to comply with all applicable federal, state, and local laws, including but not limited to:</p>
          <ul>
            <li>Financial regulations and anti-money laundering (AML) laws</li>
            <li>Know Your Customer (KYC) requirements in your jurisdiction</li>
            <li>Tax reporting obligations for cryptocurrency transactions</li>
            <li>Sanctions and restricted entity lists (OFAC, etc.)</li>
            <li>All other cryptocurrency and securities laws applicable to your location</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>15. Severability</h2>
          <p>
            If any provision of these Terms is found to be unenforceable, that provision shall be severed, and the remaining Terms shall remain in full force and effect.
          </p>
        </section>

        <section className="terms-section">
          <h2>16. Entire Agreement</h2>
          <p>
            These Terms, combined with our Privacy Policy, constitute the entire agreement between you and MediCoin (managed by MediCureOn LLC) regarding your use of the Services and participation in the ICO to access the MediCureOn Wellness Platform.
          </p>
        </section>

        <section className="terms-section">
          <h2>17. Contact Information</h2>
          <ul className="contact-list">
            <li><strong>Legal Inquiries:</strong> legal@medicureon.com</li>
            <li><strong>ICO Support:</strong> support@medicureon.com</li>
            <li><strong>Security Issues:</strong> security@medicureon.com</li>
            <li><strong>Website:</strong> www.medicureon.com</li>
            <li><strong>Address:</strong> Milwaukee, Wisconsin, USA</li>
          </ul>
        </section>

        <section className="terms-section">
          <h2>18. User Acknowledgment</h2>
          <p>
            By clicking "I Agree" or accessing the MediCoin ICO platform, you acknowledge that:
          </p>
          <ul>
            <li>You have read, understood, and agree to these Terms of Use</li>
            <li>You understand the risks associated with cryptocurrency and token investments</li>
            <li>You are solely responsible for your purchase decisions and outcomes</li>
            <li>You have verified your legal eligibility to participate in the ICO</li>
            <li>You accept all terms and conditions outlined herein</li>
          </ul>
        </section>

        <div className="terms-footer">
          <p><strong>Last Updated:</strong> November 8, 2025</p>
          <p><strong>MediCoin | Managed by MediCureOn LLC | Powering Healthcare with DeFi</strong></p>
        </div>
      </div>
    </div>
  );
}
